export const cleanSelectionRects = rectArray => {
  const overlappingIndexes = [];
  return rectArray.filter((currentRect, currentIndex, rects) => {
    if (overlappingIndexes.includes(currentIndex)) {
      return true;
    }
    const innerSelectionRect = rects.find((rect, index) => {
      if (index === currentIndex) {
        return false;
      }
      const thisBox = [[currentRect.x, currentRect.y], [currentRect.x + currentRect.width, currentRect.y + currentRect.height]];
      const otherBox = [[rect.x, rect.y], [rect.x + rect.width, rect.y + rect.height]];
      if (otherBox[0][0] >= thisBox[0][0] && otherBox[0][1] >= thisBox[0][1]) {
        if (otherBox[1][0] <= thisBox[1][0] && otherBox[1][1] <= thisBox[1][1]) {
          overlappingIndexes.push(index);
          return true;
        }
      }
      return false;
    });
    if (innerSelectionRect !== undefined) {
      return false;
    }
    return true;
  });
};